module.exports = __webpack_public_path__ + "img/shop.aefd7a24.svg";